import { useNavigate } from '@tanstack/react-router';
import { Box } from '#core/components';
import logoSrc from '#shared/assets/images/logomark-main.svg';

import styles from './Logo.module.css';

export const Logo = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({ to: '/' });
  };

  return (
    <Box
      onClick={handleClick}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          handleClick();
        }
      }}
      tabIndex={0}
      w="fit-content"
    >
      <img alt="Metto" className={styles.logo} src={logoSrc} />
    </Box>
  );
};
